module.exports = {
	"dk": [
		{
			"name": "Viasport",
			"id": "4a529436-dde5-4e18-9672-eb2de972bece",
			"urls": [
				"tv3sport.dk",
				"viasport.services"
			],
			"urlHash": [
				769928754,
				-622947034
			]
		},
		{
			"name": "embed-tool",
			"id": "db72669e-e5f6-430f-844f-829ffe42f85b",
			"urls": [
				"tv3sport.dk",
				"viasport.services"
			],
			"urlHash": [
				769928754,
				-622947034
			]
		},
		{
			"name": "XLByg",
			"id": "be574042-8bf4-445c-b3ce-3373d72f0870",
			"urls": [
				"xl-byg.dk"
			],
			"urlHash": [
				1302263102
			],
			"customPlayerConfig": {
				"freewheel": {
					"networkId": "510546"
				},
				"adBlockerBlocker": {
					"enabled": false
				}
			}
		},
		{
			"name": "Ekstrabladet",
			"id": "fa2ded0b-e3b3-4552-9c1c-ca8c34f64487",
			"urls": [
				"eb.dk",
				"ekstrabladet.dk",
				"fodbold.nu",
				"jppol.net"
			],
			"urlHash": [
				96242552,
				-1423852765,
				915501237,
				-1090130314
			],
			"customPlayerConfig": {
				"googleAnalytics": {
					"trackers": [
						{
							"tid": "UA-37272945-12"
						}
					],
					"progressResolution": 100
				},
				"freewheel": {
					"networkId": "382152"
				},
				"adBlockerBlocker": {
					"enabled": false
				}
			}
		},
		{
			"name": "Lokalavisen-dk/aarhus",
			"id": "fe094848-06e4-4fb9-a37c-8cb883caeb7a",
			"urls": [
				"aarhus.lokalavisen.dk"
			],
			"urlHash": [
				1147907284
			],
			"customPlayerConfig": {
				"freewheel": {
					"networkId": "511685"
				},
				"adBlockerBlocker": {
					"enabled": false
				}
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/config/partners.json
// module id = 1069
// module chunks = 1 3